import cx from 'classnames'
import React from 'react'

import styles from './progress-bar.module.css'

export type Themes = 'alpha' | 'light'

export interface Props {
  theme?: Themes
  progress?: number
}

const ProgressBar: React.FC<Props> = ({ progress = 0, theme = 'alpha' }) => {
  const percentage = progress > 1 ? 100 : progress * 100

  return (
    <div className={cx(styles.container, styles[theme])}>
      <div className={cx(styles.progress, styles[theme])} style={{ width: `${percentage}%` }} test-id="progressbar" />
    </div>
  )
}

export default ProgressBar
